/* @ngInject */
const settingData = (
  settingLabels
) => {
  const self = {}

  self.general = {
    checkboxs: {
      backButton: {
        label: settingLabels.fields.checkboxs.backButton,
        model: true,
      },
      calendar: {
        label: settingLabels.fields.checkboxs.calendar,
        model: false,
      },
      scrollTop: {
        label: settingLabels.fields.checkboxs.scrollTop,
        model: true,
      },
      largeMode: {
        label: settingLabels.fields.checkboxs.largeMode,
        model: false,
      },
      advancedSearch: {
        label: settingLabels.fields.checkboxs.advancedSearch,
        model: true,
      },
    },

    inputs: {

    },

    sliders: {
      autocompleteTimer: {
        model: 1,
        label: settingLabels.fields.sliders.autocompleteTimer,
        options: {
          showTicks: true,
          showSelectionBar: true,
          hidePointerLabels: true,
          hideLimitLabels: true,
          stepsArray: [{
            value: 0,
            legend: 'Immédiat',
          }, {
            value: 0.2,
          }, {
            value: 0.5,
            legend: '0.5s',
          }, {
            value: 0.8,
          }, {
            value: 1,
            legend: '1s',
          }, {
            value: 1.5,
          }, {
            value: 2,
            legend: '2s',
          }, {
            value: 4,
          }, {
            value: -1,
            legend: 'Jamais',
          },],
        },
      },
      displayedItemNumber: {
        model: 20,
        label: settingLabels.fields.sliders.displayedItemNumber,
        options: {
          showTicks: true,
          showSelectionBar: true,
          hidePointerLabels: true,
          hideLimitLabels: true,
          stepsArray: [{
            value: 1,
            legend: '1',
          }, {
            value: 5,
          }, {
            value: 10,
            legend: '10',
          }, {
            value: 15,
          }, {
            value: 20,
            legend: '20',
          }, {
            value: 30,
          }, {
            value: 50,
            legend: '50',
          }, {
            value: 75,
          }, {
            value: 100,
            legend: '100',
          },],
        },
      },
      toastTimer: {
        model: 5,
        label: settingLabels.fields.sliders.toastTimer,
        options: {
          showTicks: true,
          showSelectionBar: true,
          hidePointerLabels: true,
          hideLimitLabels: true,
          stepsArray: [{
            value: 0,
            legend: 'Aucun',
          }, {
            value: 1,
          }, {
            value: 2,
            legend: '2s',
          }, {
            value: 3.5,
          }, {
            value: 5,
            legend: '5s',
          }, {
            value: 6.5,
          }, {
            value: 8,
            legend: '8s',
          }, {
            value: 10,
          }, {
            value: -1,
            legend: 'Toujours',
          },],
        },
      },

    },
  }

  return self
}
export default settingData



// WEBPACK FOOTER //
// ./public/javascript/sygem/setting/services/data.service.js